module.exports = __webpack_public_path__ + "static/media/Data_Business_Trends.91bb5c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Data_Business_Trends.png
// module id = 23
// module chunks = 0